import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSpring } from '@react-spring/web';
import { useLayoutEffect, useState } from 'react';
import { ButtonWrapper, DivWrapper } from './styles';
const Notice = ({ children, isSuccess, onClick, describedBy, className, dismissButtonAriaLabel = 'Dismiss', }) => {
    const [isReady, setIsReady] = useState(false);
    const springProps = useSpring({
        to: {
            height: isReady ? 'auto' : 0,
            opacity: isReady ? 1 : 0,
            transform: isReady ? 'scale(1)' : 'scale(0.85)',
        },
        config: { mass: 5, tension: 350, friction: 40 },
    });
    useLayoutEffect(() => {
        setIsReady(true);
    }, []);
    const props = {
        className,
        $isSuccess: isSuccess,
        style: springProps,
    };
    const staticAriaProps = {
        role: 'alert',
        'aria-live': 'polite',
    };
    const ariaProps = Object.assign(Object.assign({}, staticAriaProps), { 'aria-invalid': !isSuccess, 'aria-describedby': describedBy });
    return (_jsxs(DivWrapper, Object.assign({}, props, { children: [onClick ? _jsx(ButtonWrapper, { onClick: onClick, "aria-label": dismissButtonAriaLabel }) : null, _jsx("span", Object.assign({}, ariaProps, { children: children }))] })));
};
export default Notice;
//# sourceMappingURL=index.js.map